"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var ActionDebrief_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionDebrief = void 0;
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const Thing_1 = require("lincd-schema/lib/shapes/Thing");
const irlcg_1 = require("../ontologies/irlcg");
const sioc_1 = require("lincd-sioc/lib/ontologies/sioc");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const UserAccount_1 = require("lincd-sioc/lib/shapes/UserAccount");
const Topic_1 = require("./Topic");
const Server_1 = require("lincd-server-utils/lib/utils/Server");
const Team_1 = require("./Team");
const ShapeSet_1 = require("lincd/lib/collections/ShapeSet");
let ActionDebrief = ActionDebrief_1 = class ActionDebrief extends Thing_1.Thing {
    get creator() {
        return this.getOneAs(sioc_1.sioc.has_creator, UserAccount_1.UserAccount);
    }
    set creator(val) {
        this.overwrite(sioc_1.sioc.has_creator, val.node);
    }
    get team() {
        return this.getOneAs(irlcg_1.irlcg.team, Team_1.Team);
    }
    set team(val) {
        this.overwrite(irlcg_1.irlcg.team, val.namedNode);
    }
    get topic() {
        return this.getOneAs(irlcg_1.irlcg.topic, Topic_1.Topic);
    }
    set topic(val) {
        this.overwrite(irlcg_1.irlcg.topic, val.namedNode);
    }
    get debriefplanGrowingEdge() {
        return this.getValue(irlcg_1.irlcg.debriefplanGrowingEdge);
    }
    set debriefplanGrowingEdge(val) {
        this.overwrite(irlcg_1.irlcg.debriefplanGrowingEdge, new models_1.Literal(val));
    }
    get debriefactionsTaken() {
        return this.getValue(irlcg_1.irlcg.debriefactionsTaken);
    }
    set debriefactionsTaken(val) {
        this.overwrite(irlcg_1.irlcg.debriefactionsTaken, new models_1.Literal(val));
    }
    get debriefDescription() {
        return this.getValue(irlcg_1.irlcg.debriefDescription);
    }
    set debriefDescription(val) {
        this.overwrite(irlcg_1.irlcg.debriefDescription, new models_1.Literal(val));
    }
    get debriefLearnings() {
        return this.getValue(irlcg_1.irlcg.debriefLearnings);
    }
    set debriefLearnings(val) {
        this.overwrite(irlcg_1.irlcg.debriefLearnings, new models_1.Literal(val));
    }
    get debriefProblems() {
        return this.getValue(irlcg_1.irlcg.debriefProblems);
    }
    set debriefProblems(val) {
        this.overwrite(irlcg_1.irlcg.debriefProblems, new models_1.Literal(val));
    }
    static loadActionDebrief(topic) {
        return Server_1.Server.call(this, 'loadActionDebrief', topic);
    }
    static getAllOf(creator) {
        return Server_1.Server.call(this, 'getAllOf', creator);
    }
    static cleanupAction(accounts, selectedAccount, scoreFn) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log(`cleaning up ActionDebrief...`);
            // get all for all accounts in the group
            // normally will get 2 accounts with all the TopicScores by the accounts
            const items = yield Promise.all(accounts.map((account) => ActionDebrief_1.getAllOf(account)));
            if (items.length >= 1) {
                // map to store highest scores by team and topic
                // the reason to map the team because we need to make sure the data is not duplicated or removed when compare
                const highestScores = new Map();
                // map to store the TopicScore by team
                const teamMap = new Map();
                // group ActionDebrief items by team
                items.forEach((itemSet) => {
                    itemSet.forEach((item) => {
                        var _a, _b;
                        const teamId = (_a = item === null || item === void 0 ? void 0 : item.team) === null || _a === void 0 ? void 0 : _a.identifier;
                        if (teamId) {
                            if (!teamMap.has(teamId)) {
                                teamMap.set(teamId, []);
                            }
                            (_b = teamMap.get(teamId)) === null || _b === void 0 ? void 0 : _b.push(item);
                        }
                    });
                });
                teamMap.forEach((itemSet, teamId) => {
                    itemSet.forEach((item) => {
                        const topic = item.topic;
                        const score = scoreFn(item);
                        // check if teamId exists in the highestScores map
                        // to make sure compare data on the same team
                        if (!highestScores.has(teamId)) {
                            highestScores.set(teamId, new Map());
                        }
                        const teamScores = highestScores.get(teamId);
                        const highestScoreItem = teamScores.get(topic.value);
                        const highestScore = highestScoreItem ? scoreFn(highestScoreItem) : 0;
                        // compare the same topic and keep the highest score
                        if (!highestScoreItem || score > highestScore) {
                            teamScores.set(topic.value, item);
                            console.log('update highest score: ', item.uri);
                        }
                        else {
                            console.log('skip highest score: ', item.uri);
                        }
                    });
                });
                // convert back the highest scores from all teams into a single array
                const highestItems = new ShapeSet_1.ShapeSet(Array.from(highestScores.values()).flatMap((teamScores) => Array.from(teamScores.values())));
                // connect the final account
                for (const item of highestItems) {
                    item.creator = selectedAccount;
                    console.log('saving ActionDebrief:', item.uri, ', with account', selectedAccount.uri);
                }
                // remove the other ActionDebriefs or ActionDebriefs
                const allItems = yield ActionDebrief_1.getAllOf(selectedAccount);
                allItems.forEach((otherItem) => {
                    if (!highestItems.has(otherItem)) {
                        console.log('removing ActionDebrief:', otherItem.uri);
                        otherItem === null || otherItem === void 0 ? void 0 : otherItem.remove();
                    }
                });
            }
            console.log(`clean ActionDebrief is done.`);
        });
    }
};
exports.ActionDebrief = ActionDebrief;
ActionDebrief.targetClass = irlcg_1.irlcg.ActionDebrief;
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: sioc_1.sioc.has_creator,
        maxCount: 1,
    }),
    __metadata("design:type", UserAccount_1.UserAccount),
    __metadata("design:paramtypes", [UserAccount_1.UserAccount])
], ActionDebrief.prototype, "creator", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: irlcg_1.irlcg.team,
    }),
    __metadata("design:type", Team_1.Team),
    __metadata("design:paramtypes", [Team_1.Team])
], ActionDebrief.prototype, "team", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: irlcg_1.irlcg.topic,
        shape: Topic_1.Topic,
    }),
    __metadata("design:type", Topic_1.Topic),
    __metadata("design:paramtypes", [Topic_1.Topic])
], ActionDebrief.prototype, "topic", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.debriefplanGrowingEdge,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ActionDebrief.prototype, "debriefplanGrowingEdge", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.debriefactionsTaken,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ActionDebrief.prototype, "debriefactionsTaken", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.debriefDescription,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ActionDebrief.prototype, "debriefDescription", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.debriefLearnings,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ActionDebrief.prototype, "debriefLearnings", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.debriefProblems,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ActionDebrief.prototype, "debriefProblems", null);
exports.ActionDebrief = ActionDebrief = ActionDebrief_1 = __decorate([
    package_1.linkedShape
], ActionDebrief);
//# sourceMappingURL=ActionDebrief.js.map